import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction, toJS} from "mobx";
import PropTypes from "prop-types";

function Test(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount
    window.EvaWithSelected.registerLayout("test_chk",{
      left:["delete_icon"],
      right:["unselect_btn"]
    });

    window.EvaWithSelected.addListener("test_chk", (action, data)=>{
      console.log("FIRE ACTION", action, data, toJS(window.EvaWithSelected.items));
    })
    window.EvaWithSelectedListeners.push((items, by_id)=>{

    })
    return () => {
      // unmount
    }
  }, []);

  let chkList=[1,2,3,4,5,6,7,8,9,10]
  // window.EvaWithSelectedListeners

  return (
    <div>
      {chkList.map((num)=>{
        return (
          <div className="pbottom10" key={num}>
            <label>
              <input type="checkbox" onChange={(e)=>{
                if(e.target.checked) {
                  window.EvaWithSelected.selectItem("test_chk", { id: num});
                } else {
                  window.EvaWithSelected.unselectItem("test_chk", { id: num});
                }
              }} checked={window.EvaWithSelected.isSelected("test_chk", num)} /><span></span> <span className="vam dib">Чекбокс 1</span>
            </label>
          </div>
        )
      })}

    </div>
  )
};

Test.defaultProps = {};

Test.propTypes = {}

export default observer(Test);
